export default "__VITE_ASSET__CMObs5vq__"